module.exports = __webpack_public_path__ + "static/img/6en.25454d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/6en.png
// module id = vybF
// module chunks = 0